import { firebaseSdk } from 'sdks/firebase'

export const created = firebaseSdk.firestore.Timestamp.fromDate(
  new Date(1000000000000)
)
